module.exports = __webpack_public_path__ + "static/files/nezar.d5af6aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nezar.jpg
// module id = KKTn
// module chunks = 0